import { paymentStatus } from "@/utils/paymentMethods";
import MundUTMify from "../icons/MundUTMify";
import UtmKit from "../icons/UtmKit";
import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";

export default function UTMify() {
  return (
    <IntegrationTable
      integrationKey='utmfy'
      title='UTMify'
      main_icon={<MundUTMify />}
      icon={<UtmKit />}
      fixedOptions={{
        active_statuses: [
          ...paymentStatus,
          "chargeback",
        ],
      }}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.status,
      ]}
    />
  );
}
